(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class NavigationContext extends HTMLElement {
    connectedCallback() {
      this.storageKey = this.dataset.storageKey;
      this.tabs = Array.from(this.querySelectorAll('[data-navigation-context-target]'));
      this.panels = Array.from(this.querySelectorAll('[data-navigation-context-panel]'));
      this.contextIds = [...new Set(this.tabs.map((tab) => tab.dataset.navigationContextTarget))];
      this.desktopHoverQuery = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)');
      this.desktopDisclosureListeners = [];
      this.hoverCloseTimers = new Map();
      this.handleDesktopMenuAlignment = () => this.alignDesktopMenuColumns();
      this.menuDrawerDetails = this.querySelector('#Details-menu-drawer-container');
      this.headerSection = this.closest('#shopify-section-header');
      window.addEventListener('resize', this.handleDesktopMenuAlignment);

      if (this.menuDrawerDetails) {
        this.menuDrawerSummary = this.menuDrawerDetails.querySelector(':scope > summary');
        this.handleMenuDrawerClick = () => {
          if (!this.menuDrawerDetails.open) this.prepareMobilePageScrollLock();
        };
        this.handleMenuDrawerToggle = () => {
          if (this.menuDrawerDetails.open) {
            this.lockMobilePageScroll();
          } else {
            this.unlockMobilePageScroll();
          }
        };
        this.menuDrawerSummary.addEventListener('click', this.handleMenuDrawerClick, true);
        this.menuDrawerDetails.addEventListener('toggle', this.handleMenuDrawerToggle);
      }

      this.querySelectorAll('.navigation-context__desktop .navigation-context__disclosure').forEach((disclosure) => {
        const summary = disclosure.querySelector(':scope > summary');

        const handleMouseEnter = () => {
          if (!this.desktopHoverQuery.matches) return;
          this.clearHoverClose(disclosure);
          this.closeDesktopDisclosures(disclosure, 'hover');
          this.setDesktopDisclosure(disclosure, true, 'hover');
        };

        const handleMouseLeave = () => {
          if (!this.desktopHoverQuery.matches) return;
          this.clearHoverClose(disclosure);
          const timer = window.setTimeout(() => {
            this.setDesktopDisclosure(disclosure, false, 'hover');
            this.hoverCloseTimers.delete(disclosure);
          }, 150);
          this.hoverCloseTimers.set(disclosure, timer);
        };

        const handleClick = (event) => {
          if (!this.desktopHoverQuery.matches || event.detail === 0) return;
          if (!summary?.contains(event.target)) return;
          if (disclosure.dataset.navigationHoverOpen !== 'true' || !disclosure.open) return;
          event.preventDefault();
        };

        const handleFocusOut = () => {
          window.requestAnimationFrame(() => {
            if (!disclosure.contains(document.activeElement)) {
              this.setDesktopDisclosure(disclosure, false, 'keyboard');
            }
          });
        };

        const handleKeyDown = (event) => {
          if (event.target !== summary) return;

          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.setDesktopDisclosure(disclosure, !disclosure.open, 'keyboard');
            return;
          }

          if (event.key === 'Escape' && disclosure.open) {
            event.preventDefault();
            this.setDesktopDisclosure(disclosure, false, 'keyboard');
            summary?.focus();
          }
        };

        disclosure.addEventListener('mouseenter', handleMouseEnter);
        disclosure.addEventListener('mouseleave', handleMouseLeave);
        disclosure.addEventListener('click', handleClick);
        disclosure.addEventListener('focusout', handleFocusOut);
        disclosure.addEventListener('keydown', handleKeyDown);
        this.desktopDisclosureListeners.push({ disclosure, handleMouseEnter, handleMouseLeave, handleClick, handleFocusOut, handleKeyDown });
      });

      this.querySelectorAll('[role="tablist"]').forEach((tablist) => {
        tablist.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-navigation-context-target]');
          if (!tab) return;
          if (tab.classList.contains('is-active')) return;
          if (this.contextNavigationStarted) return;

          const contextId = tab.dataset.navigationContextTarget;
          try {
            window.sessionStorage.setItem(this.storageKey, contextId);
          } catch (error) {
            this.selectContext(contextId, false);
            return;
          }

          this.contextNavigationStarted = true;
          window.location.assign(window.Shopify?.routes?.root || '/');
        });

        tablist.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          const tabs = Array.from(tablist.querySelectorAll('[data-navigation-context-target]'));
          const currentIndex = tabs.indexOf(document.activeElement);
          if (currentIndex === -1) return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
        });
      });

      let savedContext;
      try {
        savedContext = window.sessionStorage.getItem(this.storageKey);
      } catch (error) {
        savedContext = null;
      }

      const preloadedContext = document.documentElement.dataset.navigationContextInitial;
      const initialContext = this.contextIds.includes(preloadedContext)
        ? preloadedContext
        : (this.contextIds.includes(savedContext) ? savedContext : this.contextIds[0]);
      if (initialContext) this.selectContext(initialContext, false);

      const desktopTab = this.querySelector('.navigation-context__desktop .navigation-context__tab');
      if (desktopTab && document.fonts && window.matchMedia('(min-width: 1200px)').matches) {
        const style = getComputedStyle(desktopTab);
        const fontsReady = Promise.all([
          document.fonts.load(`${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`, desktopTab.textContent),
          document.fonts.load(`${style.fontStyle} ${getComputedStyle(this).fontWeight} ${style.fontSize} ${style.fontFamily}`)
        ]).catch(() => {});
        Promise.race([fontsReady, new Promise(resolve => setTimeout(resolve, 1200))]).then(() => {
          if (this.isConnected) this.setAttribute('data-navigation-ready', '');
        });
      } else {
        this.setAttribute('data-navigation-ready', '');
      }

      if (window.Shopify && Shopify.designMode) {
        this.handleBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const containingPanel = event.target.closest('[data-navigation-context-panel]');
          const contextId = containingPanel?.dataset.navigationContextPanel || event.detail.blockId;
          this.selectContext(contextId, false);
        };
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }
    }

    disconnectedCallback() {
      if (this.menuDrawerDetails) {
        this.menuDrawerSummary.removeEventListener('click', this.handleMenuDrawerClick, true);
        this.menuDrawerDetails.removeEventListener('toggle', this.handleMenuDrawerToggle);
        this.unlockMobilePageScroll();
      }

      if (this.handleBlockSelect) {
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      this.desktopDisclosureListeners.forEach(({ disclosure, handleMouseEnter, handleMouseLeave, handleClick, handleFocusOut, handleKeyDown }) => {
        disclosure.removeEventListener('mouseenter', handleMouseEnter);
        disclosure.removeEventListener('mouseleave', handleMouseLeave);
        disclosure.removeEventListener('click', handleClick);
        disclosure.removeEventListener('focusout', handleFocusOut);
        disclosure.removeEventListener('keydown', handleKeyDown);
      });
      this.hoverCloseTimers.forEach((timer) => window.clearTimeout(timer));
      window.removeEventListener('resize', this.handleDesktopMenuAlignment);
    }

    alignDesktopMenuColumns() {
      if (!this.desktopHoverQuery.matches) return;

      this.querySelectorAll('.navigation-context__desktop .navigation-context__menu').forEach((menu) => {
        const menuList = menu.querySelector(':scope > .navigation-context__menu-list');
        const firstMenuTitle = menuList?.querySelector(':scope > .navigation-context__menu-item .navigation-context__menu-title');
        const firstColumn = menu.querySelector('.navigation-context__column');
        if (!menuList || !firstMenuTitle || !firstColumn || !menuList.offsetParent) return;

        const columnPadding = Number.parseFloat(window.getComputedStyle(firstColumn).paddingLeft) || 0;
        const menuBounds = menu.getBoundingClientRect();
        const menuListBounds = menuList.getBoundingClientRect();
        const inset = Math.max(0, firstMenuTitle.getBoundingClientRect().left - menuListBounds.left - columnPadding);
        const menuLeft = Math.max(0, menuListBounds.left - menuBounds.left);
        menu.style.setProperty('--navigation-context-menu-inset', `${inset}px`);
        menu.style.setProperty('--navigation-context-menu-left', `${menuLeft}px`);
      });
    }

    lockMobilePageScroll() {
      this.prepareMobilePageScrollLock();
      document.documentElement.classList.add('overflow-hidden-tablet');
      document.body.classList.add('overflow-hidden-tablet');
    }

    prepareMobilePageScrollLock() {
      if (this.menuPageScrollPosition !== undefined) return;
      this.menuPageScrollPosition = window.scrollY;
      document.body.style.setProperty('--menu-drawer-scroll-offset', `-${this.menuPageScrollPosition}px`);
      if (this.headerSection?.classList.contains('shopify-section-header-sticky')) {
        this.headerSection.classList.add('menu-open-from-sticky');
      }
    }

    unlockMobilePageScroll() {
      if (this.menuPageScrollPosition === undefined) return;
      const pageScrollPosition = this.menuPageScrollPosition;
      document.documentElement.classList.remove('overflow-hidden-tablet');
      document.body.classList.remove('overflow-hidden-tablet');
      document.body.style.removeProperty('--menu-drawer-scroll-offset');
      window.scrollTo(0, pageScrollPosition);
      this.headerSection?.classList.remove('menu-open-from-sticky');
      this.menuPageScrollPosition = undefined;
    }

    clearHoverClose(disclosure) {
      const timer = this.hoverCloseTimers.get(disclosure);
      if (!timer) return;
      window.clearTimeout(timer);
      this.hoverCloseTimers.delete(disclosure);
    }

    closeDesktopDisclosures(exceptDisclosure, source) {
      this.desktopDisclosureListeners.forEach(({ disclosure }) => {
        if (disclosure === exceptDisclosure) return;
        this.clearHoverClose(disclosure);
        this.setDesktopDisclosure(disclosure, false, source);
      });
    }

    setDesktopDisclosure(disclosure, isOpen, source) {
      if (disclosure.open === isOpen) return;
      disclosure.open = isOpen;
      if (isOpen) window.requestAnimationFrame(this.handleDesktopMenuAlignment);
      if (isOpen && source === 'hover') {
        disclosure.dataset.navigationHoverOpen = 'true';
      } else {
        delete disclosure.dataset.navigationHoverOpen;
      }
      disclosure.dispatchEvent(new CustomEvent('navigation-context:disclosure', {
        bubbles: true,
        detail: {
          action: isOpen ? 'open' : 'back',
          source
        }
      }));
    }

    selectContext(contextId, persist) {
      if (!this.contextIds.includes(contextId)) return;
      const selectedTab = this.tabs.find(tab => tab.dataset.navigationContextTarget === contextId);
      document.documentElement.dataset.homepageContext = selectedTab.dataset.navigationContextKey;

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.navigationContextTarget === contextId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.navigationContextPanel === contextId;
        panel.hidden = !isActive;
        if (!isActive) {
          panel.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
          panel.querySelectorAll('.menu-opening').forEach((element) => element.classList.remove('menu-opening'));
          panel.querySelectorAll('.submenu-open').forEach((element) => element.classList.remove('submenu-open'));
          panel.querySelectorAll('summary[aria-expanded="true"]').forEach((summary) => {
            summary.setAttribute('aria-expanded', 'false');
          });
        }
      });

      window.requestAnimationFrame(this.handleDesktopMenuAlignment);

      if (persist) {
        try {
          window.sessionStorage.setItem(this.storageKey, contextId);
        } catch (error) {
          return;
        }
      }
    }
  }

  if (!customElements.get('navigation-context')) {
    customElements.define('navigation-context', NavigationContext);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-shopify"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
